import classNames from 'classnames';
import { type ReactElement } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { ROUTES } from '@/constants/routes.constants';

import { ReactComponent as LogoCGN } from '../../assets/images/logo-cgn.svg';
import { ReactComponent as LogoCTN } from '../../assets/images/logo-ctn.svg';

type IFooterProps = {
	readonly className?: string;
	readonly origin: string;
};

export default function Footer({ className = '', origin }: IFooterProps): ReactElement {
	const footerClassName = classNames('c-pnp-footer', className);
	const location = useLocation();
	const datos = location.state as {origin: string} | undefined;
	
	return (
		<footer className={footerClassName}>
			<a href="https://www.notariado.org" rel="noopener noreferrer" target="_blank">
				<LogoCGN className="c-pnp-footer__brand c-pnp-footer__brand--cgn" />
			</a>
			<div className="c-pnp-footer__info">
				<p className="c-pnp-footer__copy">&copy; {new Date().getFullYear()}, Consejo General del Notariado</p>
				<ul className="c-pnp-footer__list">
					<li className="c-pnp-footer__item">
						<Link className="c-pnp-footer__link" to={ROUTES.AVISO_LEGAL} state={{origin: datos?.origin ?? origin}}>
							Aviso Legal
						</Link>
					</li>
					<li className="c-pnp-footer__item">
						<Link className="c-pnp-footer__link" to={ROUTES.ACCESIBILIDAD} state={{origin: datos?.origin ?? origin}}>
							Accesibilidad
						</Link>
					</li>
					<li className="c-pnp-footer__item">
						<Link className="c-pnp-footer__link" to={ROUTES.POLITICA_COOKIES} state={{origin: datos?.origin ?? origin}}>
							Política de cookies
						</Link>
					</li>
				</ul>
			</div>
			<a href="https://www.ctnotariado.com" rel="noopener noreferrer" target="_blank">
				<LogoCTN className="c-pnp-footer__brand c-pnp-footer__brand--ctn" />
			</a>
		</footer>
	);
}
